import { DeviceTypes } from '@eppendorf/app-configs';
import { Badge } from '@eppendorf/vnls-react-components';

import { DashedBoxCSS } from '$components/dashed-box/dashed-box';
import { DetailsGroup } from '$components/details-group/details-group';
import { DetailsItem } from '$components/details-item/details-item';
import { Divider } from '$components/divider/divider';
import { StatusMessage } from '$components/status-message/status-message';
import { DeviceListItem } from '$features/audit-events/components/device-list-item/device-list-item';
import { UserListItem } from '$features/audit-events/components/user-list-item/user-list-item';

export function PlaygroundPage() {
  return (
    <div className="p-m">
      <h1 className="font-size-xxl font-weight-bold m-bottom-l">
        Playground - Component Testing
      </h1>
      <div className="p-m bg-white">
        <div className="bg-gray-100 p-l">
          <h2 className="font-size-xl font-weight-semibold color-gray-700 m-bottom-m">
            Details
          </h2>
          <div className="bg-white p-l flex flex__dir--column gap-8xl">
            <DetailsItem label="Devices" gap="l">
              <DeviceListItem
                name="CryoVault"
                model="Eppendorf Freezer F740"
                type={DeviceTypes.FREEZER}
              />
            </DetailsItem>
            <DetailsItem label="Error">
              Error: Device ‘ESS1LQ950195’ does not support registration process
            </DetailsItem>

            <div className="flex flex__dir--column gap-xxl">
              <DetailsGroup label="New">
                <DetailsItem label="Device name" paddingTop="m">
                  CryoSecure
                </DetailsItem>
                <DetailsItem label="Custom inventory ID" paddingTop="m">
                  1234XYZ
                </DetailsItem>
                <DetailsItem label="Site" paddingTop="m">
                  Eppendorf
                </DetailsItem>
              </DetailsGroup>

              <DetailsGroup label="Before">
                <DetailsItem label="Device name" paddingTop="m">
                  CryoFreezer
                </DetailsItem>
                <DetailsItem label="Custom inventory ID" paddingTop="m">
                  –
                </DetailsItem>
                <DetailsItem label="Site" paddingTop="m">
                  –
                </DetailsItem>
              </DetailsGroup>
            </div>

            <DetailsItem label="Status">
              <div>
                <Badge color="green" size="small">
                  Successful
                </Badge>
              </div>
            </DetailsItem>
            <DetailsItem label="Event">
              <StatusMessage
                status="warning"
                text="Relative Humidity above alert limit 86 %."
              />
            </DetailsItem>
            <DetailsItem label="Notification rule">Power supply monitoring</DetailsItem>
            <DetailsItem label="Devices" gap="l">
              <DeviceListItem
                name="Freezer Simulator"
                model="Eppendorf Freezer F740"
                type={DeviceTypes.FREEZER}
              />
              <DeviceListItem
                name="BioSecure Freezer"
                model="Eppendorf Freezer F740"
                type={DeviceTypes.FREEZER}
              />
              <DeviceListItem
                name="CryoStorage"
                model="Eppendorf Freezer F740"
                type={DeviceTypes.FREEZER}
              />
              <DeviceListItem
                name="CryoShield"
                model="Eppendorf Freezer F740"
                type={DeviceTypes.FREEZER}
              />
            </DetailsItem>
            <DetailsItem label="Incident">
              <StatusMessage
                status="info"
                text="Ambient Temperature normalized"
                prefix="Info: "
              />
            </DetailsItem>
            <DetailsItem label="Recipients" gap="l">
              <UserListItem name="Name Surname" userRole="Lab Manager" />
              <UserListItem name="Name Surname" userRole="Lab Manager" />
              <UserListItem name="Name Surname" userRole="Lab Manager" />
            </DetailsItem>

            <DetailsItem label="Acknowledged">by Name Surname</DetailsItem>
            <DetailsItem label="User">
              <UserListItem name="Albert Flores" userRole="Lab Manager" />
            </DetailsItem>
          </div>
        </div>

        <div className="bg-gray-100 p-l">
          <h2 className="font-size-xl font-weight-semibold color-gray-700 m-bottom-m">
            Details
          </h2>
          <div className="bg-white p-l flex flex__dir--column">
            <h2 className="m-bottom-m">General information</h2>

            <DetailsItem label="Timestamp" paddingTop="s">
              <span>{`<Timestamp>`}</span>
            </DetailsItem>

            <DetailsItem label="Type" paddingTop="s">
              <span>{`<Type>`}</span>
            </DetailsItem>

            <DetailsItem label="Activity" paddingTop="s">
              <span>{`<Activity>`}</span>
            </DetailsItem>

            <DetailsItem label="Performed by" paddingTop="s">
              <DashedBoxCSS strokeWidth={3} width={263}>
                Outlet
              </DashedBoxCSS>
            </DetailsItem>

            <Divider />
            <h2 className="m-bottom-m font-size-xl m-top-xxl">Details</h2>
            <DashedBoxCSS strokeWidth={3} height={123}>
              Outlet
            </DashedBoxCSS>
          </div>
        </div>
      </div>
    </div>
  );
}
